import { render, staticRenderFns } from "./AMeasureProcessStepControlSimpleMessage.reg.vue?vue&type=template&id=1fa80340&scoped=true&"
import script from "./AMeasureProcessStepControlSimpleMessage.reg.vue?vue&type=script&lang=ts&"
export * from "./AMeasureProcessStepControlSimpleMessage.reg.vue?vue&type=script&lang=ts&"
import style0 from "./AMeasureProcessStepControlSimpleMessage.reg.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./AMeasureProcessStepControlSimpleMessage.reg.vue?vue&type=style&index=1&id=1fa80340&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fa80340",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VForm } from 'vuetify/lib/components/VForm';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VForm,VSpacer,VTextarea})
